import * as React from 'react';

const SvgChatOutline = (props) => (React.createElement("svg", Object.assign({ width: 24, height: 24, fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }, props),
    React.createElement("path", { d: "M9 11a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM12 12a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM17 11a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z", fill: "currentColor" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 4h17c1.66 0 3 1.34 3 3v11H12l-3 3-3-3H2V4Zm17.99 12V7c0-.55-.45-1-1-1h-15v10h2.83L9 18.18l1.59-1.59.58-.59h8.82Z", fill: "currentColor" })));

export { SvgChatOutline as default };
